import { publish } from "pubsub-js";
import React from "react";
import eventType from "../../js/events/eventType";

export const FamilyAccountBanner = ({contentType}) => {
	const MOBILE_SM = 768;
	const isMobileSm = window.innerWidth <= MOBILE_SM;
	const bannerImage = isMobileSm 
		? "https://website-hangar-assets.maxmilhas.com.br/2025/12/18/69440b6defaf4banner-conta-familia-v7-com-selo-xs.webp" 
		: "https://website-hangar-assets.maxmilhas.com.br/2025/12/16/6941c07d27a72banner-conta-familia-v2-md.webp";

	return <div className="banner-image-container">
		<a
			href="/cliente/gestao-avancada"
			onClick={() => {
				publish(eventType.ACCOUNT_FAMILY, {
					type: contentType
				})
			}}
		>
		<img src={bannerImage} />
		</a>
	</div>
};


